export enum SignupSteps {
  Details = 'details',
  Billing = 'billing',
  Review = 'review',
}

export enum SignupBillingCallbackType {
  Approved = 'approved',
  Declined = 'declined',
  Cancelled = 'cancelled',
}
